import classNames from 'classnames';
import DoubleFilter from './DoubleFilter';
import SingleFilter from './SingleFilter';
import { branchOptionsCalifnorniaIncluded } from '../../../constants/enums/RefundContacts';

const ParcelRatesFilters = ({ setFilterValue, filter }) => {
  const renderSelect = (label, key, options, disabledOptions = []) => {
    return (
      <div className="m-5 relative">
        <div>{label}:</div>
        <div className="relative">
          <select
            value={filter[key] ?? ''} // Ensure controlled component
            onChange={(e) => setFilterValue(key, e.target.value || null)} // Reset to null if empty
            className={classNames(
              'outline-none border-b border-blue-800 focus:border-blue-400 pl-2 pr-9',
            )}
          >
            <option value="">All</option>
            {options.map((option) => (
              <option
                key={`${key}-option-${option.value || option}`}
                value={option.value || option}
                disabled={disabledOptions.includes(option.value)}
              >
                {option.label || option}
              </option>
            ))}
          </select>
          {filter[key] && (
            <button
              type="button"
              onClick={() => setFilterValue(key, null)}
              className="absolute right-6 top-1/2 -translate-y-1/2 text-blue-500 hover:text-gray-700"
            >
              ✕
            </button>
          )}
        </div>
      </div>
    );
  };

  const weightUnitFilter = () =>
    renderSelect('Weight Unit', 'weightCode', [
      { value: 'kg', label: 'kg' },
      { value: 'lbs', label: 'lbs' },
    ]);

  const seaAirFilter = () =>
    renderSelect('Sea/Air', 'sae', [
      { value: 'Air', label: 'Air' },
      { value: 'Sea', label: 'Sea' },
    ]);

  const branchFilter = () =>
    renderSelect(
      'Branch Id',
      'branchId',
      branchOptionsCalifnorniaIncluded,
      branchOptionsCalifnorniaIncluded
        .filter((item) => item.isDisabled)
        .map((item) => item.value),
    );

  const statusFilter = () =>
    renderSelect('Status', 'status', [
      { label: 'Active', value: 'Active' },
      { label: 'Inactive', value: 'Inactive' },
      { label: 'Archived', value: 'Archive' },
      { label: 'Duplicated', value: 'duplicated' },
    ]);

  const deliveryModeCodeFilter = () =>
    renderSelect('Delivery Mode', 'deliveryModeCode', [
      { label: 'PU', value: 'PU' },
      { label: 'R', value: 'R' },
      { label: 'E', value: 'E' },
      { label: 'PME', value: 'PME' },
      { label: 'RP', value: 'RP' },
    ]);
  return (
    <div className="flex flex-wrap items-center text-xs">
      <SingleFilter
        title="Id"
        name="Id"
        value="id"
        type="number"
        filter={filter}
        setFilterValue={setFilterValue}
      />
      {statusFilter()}
      {branchFilter()}
      <SingleFilter
        title="Agent"
        name="Agent"
        value="agent"
        filter={filter}
        setFilterValue={setFilterValue}
        maxLength={6}
        customClassName="uppercase"
      />
      <SingleFilter
        title="Country"
        name="Country"
        value="country"
        filter={filter}
        setFilterValue={setFilterValue}
        maxLength={3}
        customClassName="uppercase"
      />
      <SingleFilter
        title="Rate Name"
        name="Rate Name"
        value="rateName"
        filter={filter}
        setFilterValue={setFilterValue}
      />
      {weightUnitFilter()}
      <DoubleFilter
        title="Weight"
        name1="From"
        value1="weightFrom"
        name2="To"
        value2="weightTo"
        type="number"
        filter={filter}
        setFilterValue={setFilterValue}
      />
      <DoubleFilter
        title="Status Date"
        name1="From"
        value1="statusFrom"
        name2="To"
        value2="statusTo"
        type="date"
        filter={filter}
        setFilterValue={setFilterValue}
      />
      {seaAirFilter()}
      {deliveryModeCodeFilter()}
      {/* <SingleFilter
        title="Delivery Mode Code"
        name="Code"
        value="deliveryModeCode"
        filter={filter}
        setFilterValue={setFilterValue}
      /> */}
      <DoubleFilter
        title="per kg/lb"
        name1="Meest"
        value1="perKgM"
        name2="Agent"
        value2="perKgA"
        type="number"
        filter={filter}
        setFilterValue={setFilterValue}
      />
      <DoubleFilter
        title="Per Each"
        name1="Meest"
        value1="perEachM"
        name2="Agent"
        value2="perEachA"
        type="number"
        filter={filter}
        setFilterValue={setFilterValue}
      />
      <DoubleFilter
        title="Delivery"
        name1="Meest"
        value1="deliveryM"
        name2="Agent"
        value2="deliveryA"
        type="number"
        filter={filter}
        setFilterValue={setFilterValue}
      />
      <DoubleFilter
        title="Insurance"
        name1="Meest"
        value1="insuranceM"
        name2="Agent"
        value2="insuranceA"
        type="number-int"
        filter={filter}
        setFilterValue={setFilterValue}
      />
      <DoubleFilter
        title="Packaging"
        name1="Meest"
        value1="packagingM"
        name2="Agent"
        value2="packagingA"
        type="number-int"
        filter={filter}
        setFilterValue={setFilterValue}
      />
      <SingleFilter
        title="First Date Time"
        name="First Date Time"
        value="firstDateTime"
        type="date"
        filter={filter}
        setFilterValue={setFilterValue}
      />
      <SingleFilter
        title="Edit Date Time"
        name="Edit Date Time"
        value="editDateTime"
        type="date"
        filter={filter}
        setFilterValue={setFilterValue}
      />
      <SingleFilter
        title="Source"
        name="Source"
        value="source"
        filter={filter}
        setFilterValue={setFilterValue}
      />
    </div>
  );
};

export default ParcelRatesFilters;
